// AUTO-GENERATED FILE - DO NOT EDIT
// Generated by scripts/build/main.ts

// Legacy exports for backward compatibility
export const assets = {
    sprites: {
      backgrounds: {
        miniGame: {
          background: "backgrounds-mini-game-background"
        },
        backgroundRoom: "backgrounds-background-room"
      },
      ui: {
        tgUi: "ui-tg-ui",
        starUi: "ui-star-ui",
        buttonChoosePet: "ui-button-choose-pet",
        buttonPlay: "ui-button-play",
        eggUi: "ui-egg-ui",
        indicatorClean: "ui-indicator-clean",
        indicatorEnergy: "ui-indicator-energy",
        indicatorMood: "ui-indicator-mood",
        indicatorSatiety: "ui-indicator-satiety",
        crystalUi: "ui-crystal-ui",
        buttonLeft: "ui-button-left",
        buttonRight: "ui-button-right",
        indicatorCrystal: "ui-indicator-crystal",
        indicatorEgg: "ui-indicator-egg"
      },
      items: {
        bowl: "items-bowl",
        lamp: "items-lamp",
        basket: "items-basket",
        soap: "items-soap",
        poop: "items-poop",
        phone: "items-phone",
        mailbox: "items-mailbox",
        gameboy: "items-gameboy",
        ball: "items-ball"
      },
      decor: {
        flower: "decor-flower",
        picture: "decor-picture",
        closet: "decor-closet",
        carpet: "decor-carpet"
      },
      food: {
        appleGreen: "food-apple-green",
        appleRed: "food-apple-red",
        chicken: "food-chicken",
        carrot: "food-carrot"
      },
      emoji: {
        emojiSleep: "emoji-emoji-sleep",
        emojiClean: "emoji-emoji-clean",
        emojiWash: "emoji-emoji-wash",
        emojiEat: "emoji-emoji-eat",
        emojiPlay: "emoji-emoji-play"
      },
      banner: "banner",
      egg: {
        eggPart2: "egg-egg-part-2",
        eggPart1: "egg-egg-part-1",
        eggBrake2: "egg-egg-brake-2",
        eggBrake1: "egg-egg-brake-1",
        egg: "egg-egg",
        eggBrake3: "egg-egg-brake-3"
      },
      icons: {
        catchFoodIcon: "icons-catch-food-icon",
        flappyPatIcon: "icons-flappy-pat-icon",
        gravityCatsIcon: "icons-gravity-cats-icon"
      },
      pets: {
        parrot: {
          dead: "pets-parrot-dead",
          normal: "pets-parrot-normal",
          sad: "pets-parrot-sad"
        },
        shark: {
          dead: "pets-shark-dead",
          normal: "pets-shark-normal",
          sad: "pets-shark-sad"
        },
        dog: {
          dead: "pets-dog-dead",
          sad: "pets-dog-sad",
          normal: "pets-dog-normal"
        },
        cat: {
          dead: "pets-cat-dead",
          normal: "pets-cat-normal",
          sad: "pets-cat-sad"
        },
        capy: {
          dead: "pets-capy-dead",
          normal: "pets-capy-normal",
          sad: "pets-capy-sad"
        }
      }
    },
    sounds: {
      miniGame: {
        success: "mini-game-success",
        hit: "mini-game-hit"
      },
      bubblesPopping: "bubbles-popping",
      chewing: "chewing",
      feeding: "feeding",
      feedSuccess: "feed-success",
      swallowing: "swallowing",
      cleanPoop: "clean-poop",
      lightSwitching: "light-switching",
      penClick: "pen-click",
      whoosh: "whoosh",
      music: {
        home: "home"
      }
    }
  } as const;

export const paths = {
    sprites: {
      "backgrounds-mini-game-background": "/assets/atlases/main.png#backgrounds-mini-game-background",
      "backgrounds-background-room": "/assets/atlases/main.png#backgrounds-background-room",
      "ui-tg-ui": "/assets/atlases/main.png#ui-tg-ui",
      "ui-star-ui": "/assets/atlases/main.png#ui-star-ui",
      "ui-button-choose-pet": "/assets/atlases/main.png#ui-button-choose-pet",
      "ui-button-play": "/assets/atlases/main.png#ui-button-play",
      "ui-egg-ui": "/assets/atlases/main.png#ui-egg-ui",
      "ui-indicator-clean": "/assets/atlases/main.png#ui-indicator-clean",
      "ui-indicator-energy": "/assets/atlases/main.png#ui-indicator-energy",
      "ui-indicator-mood": "/assets/atlases/main.png#ui-indicator-mood",
      "ui-indicator-satiety": "/assets/atlases/main.png#ui-indicator-satiety",
      "ui-crystal-ui": "/assets/atlases/main.png#ui-crystal-ui",
      "ui-button-left": "/assets/atlases/main.png#ui-button-left",
      "ui-button-right": "/assets/atlases/main.png#ui-button-right",
      "ui-indicator-crystal": "/assets/atlases/main.png#ui-indicator-crystal",
      "ui-indicator-egg": "/assets/atlases/main.png#ui-indicator-egg",
      "items-bowl": "/assets/atlases/main.png#items-bowl",
      "items-lamp": "/assets/atlases/main.png#items-lamp",
      "items-basket": "/assets/atlases/main.png#items-basket",
      "items-soap": "/assets/atlases/main.png#items-soap",
      "items-poop": "/assets/atlases/main.png#items-poop",
      "items-phone": "/assets/atlases/main.png#items-phone",
      "items-mailbox": "/assets/atlases/main.png#items-mailbox",
      "items-gameboy": "/assets/atlases/main.png#items-gameboy",
      "items-ball": "/assets/atlases/main.png#items-ball",
      "decor-flower": "/assets/atlases/main.png#decor-flower",
      "decor-picture": "/assets/atlases/main.png#decor-picture",
      "decor-closet": "/assets/atlases/main.png#decor-closet",
      "decor-carpet": "/assets/atlases/main.png#decor-carpet",
      "food-apple-green": "/assets/atlases/main.png#food-apple-green",
      "food-apple-red": "/assets/atlases/main.png#food-apple-red",
      "food-chicken": "/assets/atlases/main.png#food-chicken",
      "food-carrot": "/assets/atlases/main.png#food-carrot",
      "emoji-emoji-sleep": "/assets/atlases/main.png#emoji-emoji-sleep",
      "emoji-emoji-clean": "/assets/atlases/main.png#emoji-emoji-clean",
      "emoji-emoji-wash": "/assets/atlases/main.png#emoji-emoji-wash",
      "emoji-emoji-eat": "/assets/atlases/main.png#emoji-emoji-eat",
      "emoji-emoji-play": "/assets/atlases/main.png#emoji-emoji-play",
      banner: "/assets/atlases/main.png#banner",
      "egg-egg-part-2": "/assets/atlases/main.png#egg-egg-part-2",
      "egg-egg-part-1": "/assets/atlases/main.png#egg-egg-part-1",
      "egg-egg-brake-2": "/assets/atlases/main.png#egg-egg-brake-2",
      "egg-egg-brake-1": "/assets/atlases/main.png#egg-egg-brake-1",
      "egg-egg": "/assets/atlases/main.png#egg-egg",
      "egg-egg-brake-3": "/assets/atlases/main.png#egg-egg-brake-3",
      "icons-catch-food-icon": "/assets/atlases/main.png#icons-catch-food-icon",
      "icons-flappy-pat-icon": "/assets/atlases/main.png#icons-flappy-pat-icon",
      "icons-gravity-cats-icon": "/assets/atlases/main.png#icons-gravity-cats-icon",
      "pets-parrot-dead": "/assets/atlases/main.png#pets-parrot-dead",
      "pets-parrot-normal": "/assets/atlases/main.png#pets-parrot-normal",
      "pets-parrot-sad": "/assets/atlases/main.png#pets-parrot-sad",
      "pets-shark-dead": "/assets/atlases/main.png#pets-shark-dead",
      "pets-shark-normal": "/assets/atlases/main.png#pets-shark-normal",
      "pets-shark-sad": "/assets/atlases/main.png#pets-shark-sad",
      "pets-dog-dead": "/assets/atlases/main.png#pets-dog-dead",
      "pets-dog-sad": "/assets/atlases/main.png#pets-dog-sad",
      "pets-dog-normal": "/assets/atlases/main.png#pets-dog-normal",
      "pets-cat-dead": "/assets/atlases/main.png#pets-cat-dead",
      "pets-cat-normal": "/assets/atlases/main.png#pets-cat-normal",
      "pets-cat-sad": "/assets/atlases/main.png#pets-cat-sad",
      "pets-capy-dead": "/assets/atlases/main.png#pets-capy-dead",
      "pets-capy-normal": "/assets/atlases/main.png#pets-capy-normal",
      "pets-capy-sad": "/assets/atlases/main.png#pets-capy-sad"
    },
    sounds: {
      "mini-game-success": "/assets/audiosprites/sfx.mp3",
      "mini-game-hit": "/assets/audiosprites/sfx.mp3",
      "bubbles-popping": "/assets/audiosprites/sfx.mp3",
      chewing: "/assets/audiosprites/sfx.mp3",
      feeding: "/assets/audiosprites/sfx.mp3",
      "feed-success": "/assets/audiosprites/sfx.mp3",
      swallowing: "/assets/audiosprites/sfx.mp3",
      "clean-poop": "/assets/audiosprites/sfx.mp3",
      "light-switching": "/assets/audiosprites/sfx.mp3",
      "pen-click": "/assets/audiosprites/sfx.mp3",
      whoosh: "/assets/audiosprites/sfx.mp3",
      home: "/assets/music/home.mp3"
    }
  } as const;

// New format exports
export const atlases = {
    main: {
      key: "main",
      texture: "/assets/atlases/main.png",
      data: {
        image: "main.png",
        format: "RGBA8888",
        size: {
          w: 1851,
          h: 4096
        },
        scale: 1,
        frames: [
          {
            filename: "backgrounds-mini-game-background",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 1024,
              h: 1536
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 1024,
              h: 1536
            },
            frame: {
              x: 2,
              y: 2,
              w: 1024,
              h: 1536
            }
          },
          {
            filename: "backgrounds-background-room",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 720,
              h: 1196
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 720,
              h: 1196
            },
            frame: {
              x: 2,
              y: 1542,
              w: 720,
              h: 1196
            }
          },
          {
            filename: "ui-tg-ui",
            rotated: false,
            trimmed: true,
            sourceSize: {
              w: 1024,
              h: 1024
            },
            spriteSourceSize: {
              x: 144,
              y: 136,
              w: 752,
              h: 799
            },
            frame: {
              x: 2,
              y: 2742,
              w: 752,
              h: 799
            }
          },
          {
            filename: "ui-star-ui",
            rotated: false,
            trimmed: true,
            sourceSize: {
              w: 520,
              h: 520
            },
            spriteSourceSize: {
              x: 34,
              y: 32,
              w: 460,
              h: 446
            },
            frame: {
              x: 2,
              y: 3545,
              w: 460,
              h: 446
            }
          },
          {
            filename: "items-bowl",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 147,
              h: 95
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 147,
              h: 95
            },
            frame: {
              x: 2,
              y: 3995,
              w: 147,
              h: 95
            }
          },
          {
            filename: "decor-flower",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 84,
              h: 94
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 84,
              h: 94
            },
            frame: {
              x: 153,
              y: 3995,
              w: 84,
              h: 94
            }
          },
          {
            filename: "food-apple-green",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 75,
              h: 78
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 75,
              h: 78
            },
            frame: {
              x: 241,
              y: 3995,
              w: 75,
              h: 78
            }
          },
          {
            filename: "food-apple-red",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 75,
              h: 78
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 75,
              h: 78
            },
            frame: {
              x: 320,
              y: 3995,
              w: 75,
              h: 78
            }
          },
          {
            filename: "emoji-emoji-sleep",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 73,
              h: 75
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 73,
              h: 75
            },
            frame: {
              x: 399,
              y: 3995,
              w: 73,
              h: 75
            }
          },
          {
            filename: "banner",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 471,
              h: 434
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 471,
              h: 434
            },
            frame: {
              x: 466,
              y: 3545,
              w: 471,
              h: 434
            }
          },
          {
            filename: "items-lamp",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 106,
              h: 110
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 106,
              h: 110
            },
            frame: {
              x: 476,
              y: 3983,
              w: 106,
              h: 110
            }
          },
          {
            filename: "food-chicken",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 70,
              h: 108
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 70,
              h: 108
            },
            frame: {
              x: 586,
              y: 3983,
              w: 70,
              h: 108
            }
          },
          {
            filename: "items-basket",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 86,
              h: 104
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 86,
              h: 104
            },
            frame: {
              x: 660,
              y: 3983,
              w: 86,
              h: 104
            }
          },
          {
            filename: "items-soap",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 75,
              h: 74
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 75,
              h: 74
            },
            frame: {
              x: 750,
              y: 3983,
              w: 75,
              h: 74
            }
          },
          {
            filename: "emoji-emoji-clean",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 53,
              h: 74
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 53,
              h: 74
            },
            frame: {
              x: 829,
              y: 3983,
              w: 53,
              h: 74
            }
          },
          {
            filename: "emoji-emoji-wash",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 76,
              h: 73
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 76,
              h: 73
            },
            frame: {
              x: 886,
              y: 3983,
              w: 76,
              h: 73
            }
          },
          {
            filename: "ui-button-choose-pet",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 323,
              h: 72
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 323,
              h: 72
            },
            frame: {
              x: 966,
              y: 3983,
              w: 323,
              h: 72
            }
          },
          {
            filename: "ui-button-play",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 323,
              h: 72
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 323,
              h: 72
            },
            frame: {
              x: 1293,
              y: 3983,
              w: 323,
              h: 72
            }
          },
          {
            filename: "ui-egg-ui",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 55,
              h: 69
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 55,
              h: 69
            },
            frame: {
              x: 1620,
              y: 3983,
              w: 55,
              h: 69
            }
          },
          {
            filename: "ui-indicator-clean",
            rotated: false,
            trimmed: true,
            sourceSize: {
              w: 70,
              h: 67
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 69,
              h: 67
            },
            frame: {
              x: 1679,
              y: 3983,
              w: 69,
              h: 67
            }
          },
          {
            filename: "emoji-emoji-eat",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 84,
              h: 40
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 84,
              h: 40
            },
            frame: {
              x: 1679,
              y: 4054,
              w: 84,
              h: 40
            }
          },
          {
            filename: "ui-indicator-energy",
            rotated: false,
            trimmed: true,
            sourceSize: {
              w: 70,
              h: 67
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 69,
              h: 67
            },
            frame: {
              x: 1752,
              y: 3983,
              w: 69,
              h: 67
            }
          },
          {
            filename: "egg-egg-part-2",
            rotated: false,
            trimmed: true,
            sourceSize: {
              w: 171,
              h: 351
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 171,
              h: 350
            },
            frame: {
              x: 726,
              y: 1542,
              w: 171,
              h: 350
            }
          },
          {
            filename: "egg-egg-part-1",
            rotated: false,
            trimmed: true,
            sourceSize: {
              w: 191,
              h: 360
            },
            spriteSourceSize: {
              x: 0,
              y: 11,
              w: 191,
              h: 349
            },
            frame: {
              x: 726,
              y: 1896,
              w: 191,
              h: 349
            }
          },
          {
            filename: "icons-catch-food-icon",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 500,
              h: 333
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 500,
              h: 333
            },
            frame: {
              x: 901,
              y: 1542,
              w: 500,
              h: 333
            }
          },
          {
            filename: "icons-flappy-pat-icon",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 500,
              h: 333
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 500,
              h: 333
            },
            frame: {
              x: 726,
              y: 2249,
              w: 500,
              h: 333
            }
          },
          {
            filename: "icons-gravity-cats-icon",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 500,
              h: 333
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 500,
              h: 333
            },
            frame: {
              x: 941,
              y: 1879,
              w: 500,
              h: 333
            }
          },
          {
            filename: "items-poop",
            rotated: false,
            trimmed: true,
            sourceSize: {
              w: 256,
              h: 256
            },
            spriteSourceSize: {
              x: 70,
              y: 57,
              w: 131,
              h: 119
            },
            frame: {
              x: 726,
              y: 2586,
              w: 131,
              h: 119
            }
          },
          {
            filename: "egg-egg-brake-2",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 223,
              h: 285
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 223,
              h: 285
            },
            frame: {
              x: 758,
              y: 2709,
              w: 223,
              h: 285
            }
          },
          {
            filename: "food-carrot",
            rotated: false,
            trimmed: true,
            sourceSize: {
              w: 55,
              h: 117
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 55,
              h: 116
            },
            frame: {
              x: 861,
              y: 2586,
              w: 55,
              h: 116
            }
          },
          {
            filename: "ui-indicator-mood",
            rotated: false,
            trimmed: true,
            sourceSize: {
              w: 70,
              h: 67
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 69,
              h: 67
            },
            frame: {
              x: 920,
              y: 2586,
              w: 69,
              h: 67
            }
          },
          {
            filename: "items-phone",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 92,
              h: 46
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 92,
              h: 46
            },
            frame: {
              x: 920,
              y: 2657,
              w: 92,
              h: 46
            }
          },
          {
            filename: "ui-indicator-satiety",
            rotated: false,
            trimmed: true,
            sourceSize: {
              w: 70,
              h: 67
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 69,
              h: 67
            },
            frame: {
              x: 993,
              y: 2586,
              w: 69,
              h: 67
            }
          },
          {
            filename: "egg-egg-brake-1",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 223,
              h: 284
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 223,
              h: 284
            },
            frame: {
              x: 758,
              y: 2998,
              w: 223,
              h: 284
            }
          },
          {
            filename: "items-mailbox",
            rotated: false,
            trimmed: true,
            sourceSize: {
              w: 256,
              h: 256
            },
            spriteSourceSize: {
              x: 43,
              y: 7,
              w: 181,
              h: 240
            },
            frame: {
              x: 758,
              y: 3286,
              w: 181,
              h: 240
            }
          },
          {
            filename: "egg-egg",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 223,
              h: 284
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 223,
              h: 284
            },
            frame: {
              x: 941,
              y: 3530,
              w: 223,
              h: 284
            }
          },
          {
            filename: "decor-picture",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 154,
              h: 154
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 154,
              h: 154
            },
            frame: {
              x: 941,
              y: 3818,
              w: 154,
              h: 154
            }
          },
          {
            filename: "items-gameboy",
            rotated: false,
            trimmed: true,
            sourceSize: {
              w: 160,
              h: 220
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 160,
              h: 219
            },
            frame: {
              x: 943,
              y: 3286,
              w: 160,
              h: 219
            }
          },
          {
            filename: "emoji-emoji-play",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 60,
              h: 63
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 60,
              h: 63
            },
            frame: {
              x: 1099,
              y: 3818,
              w: 60,
              h: 63
            }
          },
          {
            filename: "items-ball",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 60,
              h: 59
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 60,
              h: 59
            },
            frame: {
              x: 1099,
              y: 3885,
              w: 60,
              h: 59
            }
          },
          {
            filename: "ui-crystal-ui",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 70,
              h: 58
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 70,
              h: 58
            },
            frame: {
              x: 1163,
              y: 3818,
              w: 70,
              h: 58
            }
          },
          {
            filename: "ui-button-left",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 47,
              h: 51
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 47,
              h: 51
            },
            frame: {
              x: 1163,
              y: 3880,
              w: 47,
              h: 51
            }
          },
          {
            filename: "ui-button-right",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 47,
              h: 51
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 47,
              h: 51
            },
            frame: {
              x: 1214,
              y: 3880,
              w: 47,
              h: 51
            }
          },
          {
            filename: "ui-indicator-crystal",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 60,
              h: 50
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 60,
              h: 50
            },
            frame: {
              x: 1265,
              y: 3880,
              w: 60,
              h: 50
            }
          },
          {
            filename: "ui-indicator-egg",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 41,
              h: 50
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 41,
              h: 50
            },
            frame: {
              x: 1329,
              y: 3880,
              w: 41,
              h: 50
            }
          },
          {
            filename: "egg-egg-brake-3",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 287,
              h: 265
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 287,
              h: 265
            },
            frame: {
              x: 985,
              y: 2707,
              w: 287,
              h: 265
            }
          },
          {
            filename: "pets-parrot-dead",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 167,
              h: 217
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 167,
              h: 217
            },
            frame: {
              x: 1016,
              y: 2976,
              w: 167,
              h: 217
            }
          },
          {
            filename: "pets-parrot-normal",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 167,
              h: 217
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 167,
              h: 217
            },
            frame: {
              x: 1187,
              y: 2976,
              w: 167,
              h: 217
            }
          },
          {
            filename: "pets-parrot-sad",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 167,
              h: 217
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 167,
              h: 217
            },
            frame: {
              x: 1107,
              y: 3197,
              w: 167,
              h: 217
            }
          },
          {
            filename: "pets-shark-dead",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 204,
              h: 211
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 204,
              h: 211
            },
            frame: {
              x: 1168,
              y: 3418,
              w: 204,
              h: 211
            }
          },
          {
            filename: "pets-shark-normal",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 203,
              h: 211
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 203,
              h: 211
            },
            frame: {
              x: 1278,
              y: 3197,
              w: 203,
              h: 211
            }
          },
          {
            filename: "decor-closet",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 209,
              h: 174
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 209,
              h: 174
            },
            frame: {
              x: 1168,
              y: 3633,
              w: 209,
              h: 174
            }
          },
          {
            filename: "decor-carpet",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 475,
              h: 166
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 475,
              h: 166
            },
            frame: {
              x: 1374,
              y: 3811,
              w: 475,
              h: 166
            }
          },
          {
            filename: "pets-shark-sad",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 203,
              h: 211
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 203,
              h: 211
            },
            frame: {
              x: 1376,
              y: 3412,
              w: 203,
              h: 211
            }
          },
          {
            filename: "pets-dog-dead",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 197,
              h: 211
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 197,
              h: 211
            },
            frame: {
              x: 1583,
              y: 3412,
              w: 197,
              h: 211
            }
          },
          {
            filename: "pets-dog-sad",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 197,
              h: 211
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 197,
              h: 211
            },
            frame: {
              x: 1230,
              y: 2216,
              w: 197,
              h: 211
            }
          },
          {
            filename: "pets-dog-normal",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 196,
              h: 211
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 196,
              h: 211
            },
            frame: {
              x: 1230,
              y: 2431,
              w: 196,
              h: 211
            }
          },
          {
            filename: "pets-cat-dead",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 192,
              h: 211
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 192,
              h: 211
            },
            frame: {
              x: 1430,
              y: 2431,
              w: 192,
              h: 211
            }
          },
          {
            filename: "pets-cat-normal",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 192,
              h: 211
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 192,
              h: 211
            },
            frame: {
              x: 1431,
              y: 2216,
              w: 192,
              h: 211
            }
          },
          {
            filename: "pets-cat-sad",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 192,
              h: 211
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 192,
              h: 211
            },
            frame: {
              x: 1276,
              y: 2646,
              w: 192,
              h: 211
            }
          },
          {
            filename: "pets-capy-dead",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 148,
              h: 211
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 148,
              h: 211
            },
            frame: {
              x: 1358,
              y: 2861,
              w: 148,
              h: 211
            }
          },
          {
            filename: "pets-capy-normal",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 147,
              h: 211
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 147,
              h: 211
            },
            frame: {
              x: 1472,
              y: 2646,
              w: 147,
              h: 211
            }
          },
          {
            filename: "pets-capy-sad",
            rotated: false,
            trimmed: false,
            sourceSize: {
              w: 147,
              h: 211
            },
            spriteSourceSize: {
              x: 0,
              y: 0,
              w: 147,
              h: 211
            },
            frame: {
              x: 1485,
              y: 3076,
              w: 147,
              h: 211
            }
          }
        ]
      },
      frames: {
        backgrounds: {
          miniGame: {
            background: "backgrounds-mini-game-background"
          },
          backgroundRoom: "backgrounds-background-room"
        },
        ui: {
          tgUi: "ui-tg-ui",
          starUi: "ui-star-ui",
          buttonChoosePet: "ui-button-choose-pet",
          buttonPlay: "ui-button-play",
          eggUi: "ui-egg-ui",
          indicatorClean: "ui-indicator-clean",
          indicatorEnergy: "ui-indicator-energy",
          indicatorMood: "ui-indicator-mood",
          indicatorSatiety: "ui-indicator-satiety",
          crystalUi: "ui-crystal-ui",
          buttonLeft: "ui-button-left",
          buttonRight: "ui-button-right",
          indicatorCrystal: "ui-indicator-crystal",
          indicatorEgg: "ui-indicator-egg"
        },
        items: {
          bowl: "items-bowl",
          lamp: "items-lamp",
          basket: "items-basket",
          soap: "items-soap",
          poop: "items-poop",
          phone: "items-phone",
          mailbox: "items-mailbox",
          gameboy: "items-gameboy",
          ball: "items-ball"
        },
        decor: {
          flower: "decor-flower",
          picture: "decor-picture",
          closet: "decor-closet",
          carpet: "decor-carpet"
        },
        food: {
          appleGreen: "food-apple-green",
          appleRed: "food-apple-red",
          chicken: "food-chicken",
          carrot: "food-carrot"
        },
        emoji: {
          emojiSleep: "emoji-emoji-sleep",
          emojiClean: "emoji-emoji-clean",
          emojiWash: "emoji-emoji-wash",
          emojiEat: "emoji-emoji-eat",
          emojiPlay: "emoji-emoji-play"
        },
        banner: "banner",
        egg: {
          eggPart2: "egg-egg-part-2",
          eggPart1: "egg-egg-part-1",
          eggBrake2: "egg-egg-brake-2",
          eggBrake1: "egg-egg-brake-1",
          egg: "egg-egg",
          eggBrake3: "egg-egg-brake-3"
        },
        icons: {
          catchFoodIcon: "icons-catch-food-icon",
          flappyPatIcon: "icons-flappy-pat-icon",
          gravityCatsIcon: "icons-gravity-cats-icon"
        },
        pets: {
          parrot: {
            dead: "pets-parrot-dead",
            normal: "pets-parrot-normal",
            sad: "pets-parrot-sad"
          },
          shark: {
            dead: "pets-shark-dead",
            normal: "pets-shark-normal",
            sad: "pets-shark-sad"
          },
          dog: {
            dead: "pets-dog-dead",
            sad: "pets-dog-sad",
            normal: "pets-dog-normal"
          },
          cat: {
            dead: "pets-cat-dead",
            normal: "pets-cat-normal",
            sad: "pets-cat-sad"
          },
          capy: {
            dead: "pets-capy-dead",
            normal: "pets-capy-normal",
            sad: "pets-capy-sad"
          }
        }
      }
    }
  } as const;

export const audiosprites = {
    sfx: {
      key: "sfx",
      audio: "/assets/audiosprites/sfx.mp3",
      data: {
        resources: [
          "resources/audiosprites/sfx/mini-game/success.mp3",
          "resources/audiosprites/sfx/mini-game/hit.wav",
          "resources/audiosprites/sfx/bubbles-popping.mp3",
          "resources/audiosprites/sfx/chewing.mp3",
          "resources/audiosprites/sfx/feeding.mp3",
          "resources/audiosprites/sfx/feed-success.mp3",
          "resources/audiosprites/sfx/swallowing.mp3",
          "resources/audiosprites/sfx/clean-poop.mp3",
          "resources/audiosprites/sfx/light-switching.mp3",
          "resources/audiosprites/sfx/pen-click.mp3",
          "resources/audiosprites/sfx/whoosh.mp3"
        ],
        spritemap: {
          "mini-game-success": {
            start: 0,
            end: 2.951837,
            loop: false
          },
          "mini-game-hit": {
            start: 3.951837,
            end: 7.166463,
            loop: false
          },
          "bubbles-popping": {
            start: 8.166463,
            end: 8.670463,
            loop: false
          },
          chewing: {
            start: 9.670463,
            end: 11.110463,
            loop: false
          },
          feeding: {
            start: 12.110463,
            end: 13.142463,
            loop: false
          },
          "feed-success": {
            start: 14.142463,
            end: 15.654463,
            loop: false
          },
          swallowing: {
            start: 16.654463,
            end: 18.094463,
            loop: false
          },
          "clean-poop": {
            start: 19.094463,
            end: 20.126463,
            loop: false
          },
          "light-switching": {
            start: 21.126463,
            end: 22.398463,
            loop: false
          },
          "pen-click": {
            start: 23.398463,
            end: 25.438463,
            loop: false
          },
          whoosh: {
            start: 26.438463,
            end: 27.662463,
            loop: false
          }
        }
      },
      sounds: {
        miniGame: {
          success: "mini-game-success",
          hit: "mini-game-hit"
        },
        bubblesPopping: "bubbles-popping",
        chewing: "chewing",
        feeding: "feeding",
        feedSuccess: "feed-success",
        swallowing: "swallowing",
        cleanPoop: "clean-poop",
        lightSwitching: "light-switching",
        penClick: "pen-click",
        whoosh: "whoosh"
      }
    }
  } as const;

export const music = {
    home: "home"
  } as const;

export const musicPaths = {
    home: "/assets/music/home.mp3"
  } as const;

export const scenes = {
    currencyShopScene: "CurrencyShopScene",
    petHomeScene: "PetHomeScene",
    miniGames: {
      miniGamesListScene: "MiniGamesListScene",
      catchFoodGameScene: "CatchFoodGameScene",
      eggBrakeScene: "EggBrakeScene"
    },
    petDeathScene: "PetDeathScene",
    petCreateScene: "PetCreateScene",
    loading: {
      preloadScene: "PreloadScene",
      loadingScene: "LoadingScene"
    },
    overlays: {
      continueGameOverlay: "ContinueGameOverlay",
      statRestoreOverlay: "StatRestoreOverlay",
      mainSettingsOverlay: "MainSettingsOverlay",
      gameOverOverlay: "GameOverOverlay",
      loadingOverlay: "LoadingOverlay",
      foodShopOverlay: "FoodShopOverlay"
    }
  } as const;
